export enum VDPLinkTitles {
  Favorite = 'Favorites',
  None = '',
  Recent = 'Recently viewed',
  Suggested = 'Suggested vehicles'
}
